import clsx from 'clsx';
import { isHexColor, teamTagStyle } from './teamColors';

/** Nom de l'équipe dans sa couleur, partout où une équipe est affichée ; rien sans nom */
export function TeamTag({ name, color, className }: { name: string; color: string; className?: string }) {
  if (!name) {
    return null;
  }

  return (
    <span
      className={clsx('inline-flex px-2.5 py-0.5 rounded-full border text-xs font-medium whitespace-nowrap', className)}
      style={teamTagStyle(color)}
      data-testid="team-tag"
      data-color={isHexColor(color) ? color : undefined}
    >
      {name}
    </span>
  );
}
